<div class="body">
    <div class="header" fxLayoutAlign="space-between center">
        <div class="title">Passwort vergessen</div>
        <div class="close-button" (click)="close()">
            <i class="ju ju-close"></i>
        </div>
    </div>
    <div class="pw-header-line"></div>
    <div class="content">
        <div *ngIf="!forgettingPassword" class="input">
            <label for="email">E-Mail Adresse</label>
            <input
                    [(ngModel)]="emailForPassword"
                    class="forgot-password"
                    placeholder="E-Mail Adresse eingeben"
                    id="email"
                    type="email"
            />
        </div>
        <div class="text">
            <div *ngIf="forgettingPassword" class="text">{{ forgotPasswordMessage }}</div>
            <div *ngIf="!forgettingPassword" class="text-bottom">
                Bitte folgen Sie den in der E-Mail beschriebenen Anweisungen.
            </div>
        </div>
        <button *ngIf="!forgettingPassword" (click)="resetPassword()" [disabled]="!canForgetPassword()" class="primary"
                fxLayoutAlign="center center">
            Bestätigen
        </button>
    </div>
</div>
